import { IconLayer } from 'deck.gl';

export const iconLayer = (filtered: any, highlightedIndex: any) => {
  if (!highlightedIndex) return;
  const gpsPoint = filtered[highlightedIndex];
  if (!gpsPoint) return;
  const coordinates = [gpsPoint.lon, gpsPoint.lat];

  const data = [
    {
      coordinates,
    },
  ];

  return new IconLayer({
    id: 'icon-layer-data',
    data,
    pickable: true,

    //orange fill
    getColor: [255, 165, 0],
    getIcon: (d) => 'marker',
    sizeMaxPixels: 100,
    shouldUpdateState: (prevState: any, nextState: any) => {
      console.log('prevState', prevState);
      console.log('nextState', nextState);
    },
    iconAtlas:
      'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.png',
    iconMapping:
      'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.json',
    getSize: 40,

    getPosition: (d: any) => d.coordinates,
  });
};
